var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOpenFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.085,
    height: 35.255,
    viewBox: "0 0 47.085 35.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Open_Folder",
    "data-name": "Open Folder",
    transform: "translate(0.586 -2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(0.5 3.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M39.623,13.281V10.347a2.934,2.934,0,0,0-2.934-2.934H18.105L14.193,3.5H3.434A2.934,2.934,0,0,0,.5,6.434V33.821A2.915,2.915,0,0,0,.715,34.9m0,.02a2.934,2.934,0,0,0,2.719,1.839H36.689a2.934,2.934,0,0,0,2.836-2.23",
    transform: "translate(-0.5 -3.5)",
    fill: "none",
    stroke: "#006664",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M39.44,29.744l5.868-17.41h0a2.9,2.9,0,0,0,.078-.9A2.934,2.934,0,0,0,42.452,8.5H9.2a2.934,2.934,0,0,0-2.856,2.289h0L.61,30.135",
    transform: "translate(-0.395 1.281)",
    fill: "none",
    stroke: "#006664",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenFolder);
export default __webpack_public_path__ + "static/media/icon-open-folder.f5091d1782ec534bcfe23c8c72567f50.svg";
export { ForwardRef as ReactComponent };